import api from "./api";

class Gruppi {
    gruppi(config?: any) {
        return api.get(`/roles`, config)
    }
    gruppo(id: number | string) {
        return api.get(`/roles/${id}`)

    }
    list = this.gruppi
    retrieve = this.gruppo
}

const gruppoManager = new Gruppi()

export default gruppoManager
